<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM19 16.0002H6L4 18.0002V5.00024C4 4.45024 4.45 4.00024 5 4.00024H19C19.55 4.00024 20 4.45024 20 5.00024V15.0002C20 15.5502 19.55 16.0002 19 16.0002Z"
  />
</template>
